// Maps lowercase raw subject names to clean display names.
// Similar-looking subjects are merged to the same canonical name so they
// accumulate hours together in the report.
const ALIAS_MAP = {
  // ── SAT Math ──
  "sat math": "SAT Math",
  "sat - math": "SAT Math",
  "sat/math": "SAT Math",
  "sat (math)": "SAT Math",

  // ── SAT Reading & Writing ──
  "sat r/w": "SAT Reading & Writing",
  "sat reading and writing": "SAT Reading & Writing",
  "sat reading & writing": "SAT Reading & Writing",
  "sat rw": "SAT Reading & Writing",
  "sat r&w": "SAT Reading & Writing",
  "sat - reading and writing": "SAT Reading & Writing",
  "sat - r/w": "SAT Reading & Writing",
  "sat english": "SAT Reading & Writing",
  "sat verbal": "SAT Reading & Writing",

  // ── SAT general ──
  "sat": "SAT",

  // ── PSAT ──
  "psat": "PSAT",
  "psat math": "PSAT Math",
  "psat reading": "PSAT Reading & Writing",
  "psat r/w": "PSAT Reading & Writing",
  "psat reading and writing": "PSAT Reading & Writing",

  // ── ACT Math ──
  "act math": "ACT Math",
  "act - math": "ACT Math",

  // ── ACT Reading ──
  "act reading": "ACT Reading",
  "act - reading": "ACT Reading",

  // ── ACT English ──
  "act english": "ACT English",
  "act - english": "ACT English",

  // ── ACT Science ──
  "act science": "ACT Science",
  "act - science": "ACT Science",

  // ── ACT general ──
  "act": "ACT",

  // ── English & Reading (school subjects that all belong together) ──
  "reading": "English & Reading",
  "english": "English & Reading",
  "reading and writing": "English & Reading",
  "reading & writing": "English & Reading",
  "writing": "English & Reading",
  "english/reading": "English & Reading",
  "language arts": "English & Reading",
  "ela": "English & Reading",

  // ── School Math ──
  "math": "Math",
  "mathematics": "Math",
  "algebra": "Algebra",
  "algebra 1": "Algebra",
  "algebra 2": "Algebra",
  "algebra i": "Algebra",
  "algebra ii": "Algebra",
  "geometry": "Geometry",
  "calculus": "Calculus",
  "pre-calculus": "Pre-Calculus",
  "pre-calc": "Pre-Calculus",
  "precalculus": "Pre-Calculus",
  "precalc": "Pre-Calculus",
  "statistics": "Statistics",
  "stats": "Statistics",
  "trigonometry": "Trigonometry",
  "trig": "Trigonometry",

  // ── Science ──
  "science": "Science",
  "biology": "Biology",
  "bio": "Biology",
  "chemistry": "Chemistry",
  "chem": "Chemistry",
  "physics": "Physics",
  "earth science": "Earth Science",
  "environmental science": "Environmental Science",

  // ── AP ──
  "ap calculus": "AP Calculus",
  "ap calc": "AP Calculus",
  "ap calculus ab": "AP Calculus AB",
  "ap calculus bc": "AP Calculus BC",
  "ap statistics": "AP Statistics",
  "ap english": "AP English",
  "ap chemistry": "AP Chemistry",
  "ap biology": "AP Biology",
  "ap physics": "AP Physics",
  "ap us history": "AP US History",
  "ap world history": "AP World History",
  "ap psychology": "AP Psychology",
  "ap computer science": "AP Computer Science",

  // ── Other ──
  "history": "History",
  "us history": "US History",
  "world history": "World History",
  "social studies": "Social Studies",
  "spanish": "Spanish",
  "french": "French",
  "chinese": "Chinese",
  "mandarin": "Chinese",
  "computer science": "Computer Science",
  "cs": "Computer Science",
  "coding": "Computer Science",
  "general": "General",
  "other": "Other",
};

function titleCase(str) {
  return String(str || "")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function normalizeSubjectName(raw) {
  const key = String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
  if (!key) return "General";
  return ALIAS_MAP[key] || titleCase(raw) || "General";
}

/**
 * Takes a map of { rawSubjectName: hours } and returns a merged map of
 * { normalizedName: hours } where duplicates are summed.
 */
export function groupSubjectHours(rawHoursMap) {
  const result = {};
  for (const [subject, hours] of Object.entries(rawHoursMap || {})) {
    const name = normalizeSubjectName(subject);
    result[name] = (result[name] || 0) + Number(hours || 0);
  }
  for (const key of Object.keys(result)) {
    result[key] = Math.round(result[key] * 100) / 100;
  }
  return result;
}
